"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _titleBox = require("../styles/titleBox"),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Input = _interopRequireDefault(require("../../Input")),
    _BreadCrumbs = _interopRequireDefault(require("../../BreadCrumbs"));

require("../styles/_title-box.scss");

function pushLink(a, b) {
  return function (c) {
    c.preventDefault(), a.push(b);
  };
}

function renderSubTitle(a, b, c, d, e) {
  var f = a || b ? _react["default"].createElement("p", {
    className: (0, _classnames["default"])("title-box__subtitle", {
      "title-box__subtitle--dark-mode": e
    })
  }, a) : null;
  return a ? d && c ? _react["default"].createElement("a", {
    href: c,
    className: (0, _classnames["default"])("title-box__link", {
      "title-box__link--dark-mode": e
    }),
    onClick: pushLink(d, c)
  }, a) : f : null;
}

function TitleBox(a) {
  var b = a.title,
      c = a.breadCrumbs,
      d = a.subtitle,
      e = a.subtitleLink,
      f = a.titlePlaceHolder,
      g = a.editableTitle,
      h = a.onBlurTitle,
      i = a.onChangeTitle,
      j = a.titleIconColor,
      k = a.alwaysShowSubtitle,
      l = a.darkMode,
      m = a.titleSuffixIcon,
      n = a.history;
  if ((e || c) && !n) throw new Error("The ui-kit/TitleBox component expects a valid history prop, if subTitleLink or breadCrumbs are being used.");
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("title-box", (0, _titleBox.TITLEWRAPPER)(!!d))
  }, renderSubTitle(d, k, e, n, l), _react["default"].createElement("div", {
    className: "title-box__container"
  }, d ? _react["default"].createElement(_Icon["default"], {
    className: _titleBox.TITLEICON,
    name: "childpage",
    color: j,
    size: 10
  }) : null, _react["default"].createElement(_BreadCrumbs["default"], {
    items: c,
    darkMode: l,
    history: n
  }), _react["default"].createElement("div", {
    className: "title-box__suffix-icon-wrapper"
  }, g ? _react["default"].createElement(_Input["default"], {
    className: (0, _classnames["default"])("title-input", _titleBox.TITLEINPUT),
    styleType: "TEXT",
    defaultValue: b,
    onBlur: h,
    onChange: i,
    placeholder: f
  }) : _react["default"].createElement("h3", {
    className: (0, _classnames["default"])("title-box__text")
  }, b), m && b && _react["default"].createElement(_Icon["default"], {
    name: m,
    className: "title-box__suffix-icon",
    size: "20",
    color: l ? "white" : "black"
  }))));
}

TitleBox.displayName = "TitleBox", TitleBox.defaultProps = {
  editableTitle: !1,
  titleIconColor: "nevada",
  darkMode: !1
};

var _default = (0, _react.memo)(TitleBox);

exports["default"] = _default;